export function TextInput({
  id,
  label,
  value,
  disabled,
  onChange,
}: {
  id: string
  label: string
  disabled?: boolean
  value: string
  onChange: (value: string) => void
}) {
  const handleChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <div className="flex flex-col gap-1">
      <label className="font-semibold" htmlFor={id}>
        {label}
      </label>
      <input
        disabled={disabled}
        className={`p-4 text-old-primaryLight border-[1.5px] border-gray-300 rounded-lg ${disabled && 'bg-gray-200'}`}
        id={id}
        value={value}
        onChange={(e) => {
          handleChange(e)
        }}
      />
    </div>
  )
}
